import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {blue, cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center' as const,
    backgroundColor: white,
  },
  mainBase: {
    flex: 1,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center' as const,
    backgroundColor: cloudLightest,
  },
  header: {
    paddingVertical: 20,
    backgroundColor: white,
  },
  heading: {
    marginBottom: indent / 2,
  },
  scrollContent: {
    paddingBottom: 24,
  },
  trackingContainer: {
    height: 86,
    marginTop: 10,
  },
  scrollView: {
    height: 70,
    paddingHorizontal: 2,
  },
  trackingPref: {
    backgroundColor: white,
    marginTop: 10,
    paddingVertical: 20,
    flexDirection: 'row',
    paddingHorizontal: 15,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  focused: {
    borderColor: blue,
    borderWidth: 2,
    borderRadius: 5,
  },
  trackingIconText: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  locIcon: {
    marginHorizontal: 10,
  },
});
